import { get } from 'helpers/api';

const rootPath = '/projects';

export function fetchMetrics(projectId, startDate) {
  return get(`${rootPath}/${projectId}/metrics.json`, { params: { startDate } });
}

export function fetchFastMetrics(projectId, startDate, endDate = '') {
  return get(`${rootPath}/${projectId}/fast_metrics.json`, { params: { startDate, endDate } });
}

export function fetchAnalyticsMetrics(projectId, startDate, endDate = '') {
  return get(`${rootPath}/${projectId}/analytics.json`, { params: { startDate, endDate } });
}
